import { render, staticRenderFns } from "./AddUpdateUser.vue?vue&type=template&id=34929b5a&"
import script from "./AddUpdateUser.vue?vue&type=script&lang=js&"
export * from "./AddUpdateUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports